import { Box, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

export const ModalContent = styled(Box)({
	...flexMixin({ direction: 'column', justify: 'unset' }),
	alignSelf: 'center',
	margin: '48px 0',
});

export const ModalButtons = styled(Box)({
	...flexMixin({ justify: 'space-between' }),
	width: '100%',
});
